import UyapTakipAc from "../../../takip_ac/UyapTakipAc";
import {TaskDurum} from "../../../enum/TaskDurum";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";

export class UyapTakipTevziAlTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let takip = UyapTakipAc.fromJson(task.data);
            await takip.takipBaslat(false,false);
            task.response = takip;
            task.status = TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            console.log(e);
            throw new Error(e.message);
        }
    }

}